// Hardcoded default embeds — used when the site_embeds DB row for a
// kind is empty or unreachable. Imported by both the renderers
// (VideosStrip, InstagramReels) and the admin (SiteEmbedsAdmin) so
// the admin always shows the same items the live site is rendering.

// Four slots so the videos strip renders four independent embeds out
// of the box — editors swap each one for a different Vimeo video via
// /admin/embeds. The same ID is repeated as a placeholder until the
// editor replaces them.
export const FALLBACK_VIDEO_IDS: string[] = [
  '1188978090',
  '1188978090',
  '1188978090',
  '1188978090',
];

export const FALLBACK_REEL_IDS: string[] = [
  'DXzmH6BDw7L',
  'DXzhcOwjnvD',
  'DXzah9lgEJg',
];
